import { trans } from "@mongez/localization";
import { Form } from "@mongez/react-form";
import {
  EmailInput,
  PhoneNumberInput,
  SubmitButton,
  TextInput,
} from "~/design-system/components";
import {
  requestWeddingCakesDataAtom,
  requestWeddingCakesStepsAtom,
} from "~/modules/home/atoms";
import { useRequestOrder } from "../../hooks";
import { requestWeddingCakesPortal } from "../RequestWeddingCakesPortal";

export function RequestWeddingAccountInformation() {
  const { handleSubmitUserInformation, formData, user } = useRequestOrder({
    type: "customized",
    dataAtom: requestWeddingCakesDataAtom,
    stepsAtom: requestWeddingCakesStepsAtom,
  });

  return (
    <Form
      onSubmit={handleSubmitUserInformation}
      className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:gap-8"
    >
      <TextInput
        name="name"
        placeholder={trans("fullName")}
        label={trans("fullName")}
        defaultValue={formData?.customer?.name || user?.name}
        required
        classes={{
          wrapper: "md:col-span-2",
        }}
        autofocus
      />
      <EmailInput
        name="email"
        placeholder={trans("email")}
        label={trans("email")}
        defaultValue={formData?.customer?.email || user?.email}
        required
      />
      <PhoneNumberInput
        name="phoneNumber"
        placeholder={trans("phoneNumber")}
        label={trans("phoneNumber")}
        defaultValue={formData?.customer?.phoneNumber || user?.phoneNumber}
        id="wedding-customerPhone"
        required
      />
      <SubmitButton className="bg-primary-200 hover:bg-primary-300 border-night md:col-span-2 w-full items-center justify-center rounded-full border px-8 py-3 text-center text-base font-semibold transition-colors duration-200 sm:text-lg">
        {trans("next")}
      </SubmitButton>
    </Form>
  );
}
